import React from "react";
import Box from "@mui/material/Box";
import { ReactComponent as FileIcon } from "../../../../assets/images/KnowledgeBase/article-category.svg";

const ArticleCategory = ({ article, accentColor }) => {

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "170px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        borderRadius: "8px",
        padding: "24px",
        boxSizing: "border-box",
        justifyContent: "center",
        backgroundColor: "#FBFCFC",
      }}
    >
      <Box
        sx={{
          color: "#0C141B",
          fontFamily: "Inter",
          fontSize: "20px",
          fontWeight: 700,
          lineHeight: "34px",
        }}
      >
        Article Category
      </Box>

      {article?.categoryIds && article.categoryIds.length > 0 ? (
        article.categoryIds.map((cat, idx) => (
          <Box key={idx} sx={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
            {/* Icon aligned to top with name */}
            <FileIcon style={{ flexShrink: 0, width: "20px", height: "20px", marginTop: "5px" }} />

            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box
                sx={{
                  color: "#0C141B",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 700,
                  lineHeight: "34px",

                }}
              >
                {cat.name}
              </Box>
              <Box
                sx={{
                  color: accentColor || "#148DFD",
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Inter",
                  marginTop: '10px',
                  lineHeight: "24px",
                }}
              >
                {cat.articleCount ?? 0} ARTICLES
              </Box>
            </Box>
          </Box>
        ))
      ) : (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
          <FileIcon style={{ marginTop: "4px", flexShrink: 0 }} />
          <Box
            sx={{
              color: "#0C141B",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: 700,
              lineHeight: "24px",
            }}
          >
            General
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ArticleCategory;